module.exports = __webpack_public_path__ + "static/media/spot.8be10b99.svg";